import React, { useState } from 'react'
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import EditIcon from "@mui/icons-material/Edit";
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import AddLocationMultiple from '../../components/TemplateEditors/TemplateModals/AddLocationMultiple';

const LocationInput = (props) => {
  const { nonHT, lineName, locationData, AllCategoryList, cmtLocHolder, isPlaceHolder, item, categoryId, lineId, lineInputControlId, updateTemplate, action,
    commentId, locationValue = [], onApplySelection } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <AddLocationMultiple open={open}
        setOpen={setOpen}
        cmtLocHolder={cmtLocHolder}
        lineName={lineName}
        isPlaceHolder={isPlaceHolder}
        nonHT={nonHT}
        item={item}
        locationData={locationData}
        AllCategoryList={AllCategoryList}
        categoryId={categoryId}
        lineId={lineId}
        lineInputControlId={lineInputControlId}
        updateTemplate={updateTemplate}
        commentId={commentId}
        action={action}
        onApplySelection={onApplySelection}
        locationValue={locationValue} />
      <FormControl sx={{ m: 0, width: '100%', position: 'relative' }} variant="outlined">
        <OutlinedInput
          disabled
          className="location-input"
          size="small"
          type="text"
          fullWidth
          value={Array.isArray(locationValue) ? locationValue?.map(el => el.name).join(', ') : locationValue}
          placeholder={"Add a descriptive location"}
          sx={{ '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: 'black' } }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                disableRipple
                aria-label="edit location"
                onClick={() => setOpen(true)}
                edge="end"
                sx={{ color: "#3b3b3b !important" }}
              >
                <EditIcon sx={{ color: "#3b3b3b !important" }} />
                {!nonHT && <span className='edit-text'>Edit</span>}
              </IconButton>
            </InputAdornment>
          }
        />
        <div
          onClick={() => setOpen(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(true); }
          }}
          style={{ position: 'absolute', inset: 0, borderRadius: 4, cursor: 'pointer', background: 'transparent' }}
        />
      </FormControl>
    </>
  )
}

export default LocationInput